import './navigation';
import './header';
import './ajax-add-to-cart';

document.addEventListener("DOMContentLoaded", function() {
  const textElement = document.querySelector('.AnimateText');
  const textContent = textElement.textContent.trim();

  // Usuwamy oryginalny tekst, aby zastąpić go spanami
  textElement.textContent = '';

  // Podziel tekst na litery i otocz każdą literę w <span>
  Array.from(textContent).forEach(letter => {
      const span = document.createElement('span');
      span.textContent = letter;
      // Dodajemy klasę dla późniejszego dodania animacji
      span.style.transition = "color 0.05s ease, opacity 0.05s ease"; // Płynna zmiana koloru i przezroczystości
      textElement.appendChild(span);
  });

  // Funkcja do zmiany koloru liter w zależności od przewijania
  window.addEventListener('scroll', function() {
      const scrollY = window.scrollY;
      const windowHeight = window.innerHeight;

      // Pobieramy pozycję samego elementu, który zawiera tekst
      const elementPosition = textElement.getBoundingClientRect().top + scrollY;

      // Obliczamy, jak daleko przewinęliśmy stronę w stosunku do pozycji elementu
      const scrollPosition = (scrollY + windowHeight - elementPosition) / (windowHeight + textElement.offsetHeight);

      // Zmieniamy kolor liter w zależności od przewijania
      const letters = textElement.querySelectorAll('span');
      letters.forEach((letter, index) => {
          const triggerPosition = (index / (letters.length * 2)); // Procent, w którym dana litera powinna zmienić kolor

          if (scrollPosition > triggerPosition) {
              letter.style.opacity = 1;
              letter.style.color = '#262626'; // Nowy kolor
          } else {
              letter.style.opacity = 0.7; // Ukrywamy literę, jeśli nie osiągnęła swojego punktu
              letter.style.color = '#C9C9C9'; // Kolor początkowy
          }
      });
  });
});

